import { render } from "./headingTextAvatar.vue?vue&type=template&id=5b68c62c&scoped=true"
import script from "./headingTextAvatar.vue?vue&type=script&lang=js"
export * from "./headingTextAvatar.vue?vue&type=script&lang=js"

import "./headingTextAvatar.vue?vue&type=style&index=0&id=5b68c62c&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b68c62c"]])

export default __exports__